import React from "react";
import classNames from "classnames";
import { Trans } from "react-i18next";

export const ViewingRecords = ({
  limit,
  offset,
  count,
  className,
  noCount,
  ...props
}) => (
  <div className={classNames("text-muted small", className)} {...props}>
    <Trans>Viewing</Trans> {offset + 1} -{" "}
    {Math.min(offset + limit, noCount ? offset + limit : count)}
    {!noCount && (
      <span>
        {" "}
        <Trans>of</Trans> {count} <Trans>records</Trans>
      </span>
    )}
  </div>
);

export default ViewingRecords;
